import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";

import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";

// import IconButton from "./IconButton";
import ModelSelector from "./ModelSelector";

// Workaround for missing types in DOM
declare global {
  interface Document {
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreenEnabled
     *
     * Returns true if the document is allowed to be viewed in fullscreen mode, and false otherwise. (Firefox only)
     */
    mozFullscreenEnabled: boolean;
    /**
     * @see https://developer.mozilla.org/en-US/docs/Web/API/Document/fullscreenEnabled
     *
     * Returns true if the document is allowed to be viewed in fullscreen mode, and false otherwise. (Webkit browsers only)
     */
    webkitFullscreenEnabled: boolean;
  }
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const isFullscreenSupported: boolean =
  document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled;

type TopBarProps = {
  topBarRef: React.Ref<HTMLDivElement>;
  isMobile: boolean;
  drawerOpen: boolean;
  isFullscreen: boolean;
  featurePreviewOpen: boolean;
  disableDrawerOpen?: boolean;
  openMenu: () => void;
  closeMenu: () => void;
  toggleFullscreen: () => void;
  closeFeaturePreview: () => void;
};

export default function TopBar({
  topBarRef,
  isMobile,
  drawerOpen,
  featurePreviewOpen,
  disableDrawerOpen,
  openMenu,
  closeMenu,
}: TopBarProps) {
  const toggleDrawer = () => {
    if (drawerOpen) return closeMenu();
    openMenu();
  };

  return (
    <StyledAppBar drawerOpen={isMobile ? false : drawerOpen} ref={topBarRef}>
      <Stack direction="row" spacing={1} width="100%">
        {/* <IconButton
          sx={{
            border: isMobile ? "none" : "1px solid rgba(173, 188, 193, 0.6)",
            backgroundColor: isMobile ? "transparent" : "rgba(0, 0, 0, 0.4)",
          }}
          disableRipple
          disableTouchRipple
          disableFocusRipple
        >
          <ArrowBackIosNewRoundedIcon fontSize="small" />
        </IconButton> */}

        {isMobile && <ModelSelector />}
      </Stack>

      {!isMobile && (
        <Stack direction="row" columnGap={0.5}>
          {/* 'null' is placeholder for closing feature preview button in future, if functionality exists */}
          {featurePreviewOpen && null}

          <DrawerToggleButton
            onClick={toggleDrawer}
            disableRipple
            disableTouchRipple
            disableFocusRipple
            disabled={disableDrawerOpen}
          >
            <ArrowBackIosNewRoundedIcon
              sx={{
                transition: "transform 0.2s ease",
                transform: drawerOpen ? "rotate(180deg)" : "rotate(0)",
              }}
            />
          </DrawerToggleButton>
        </Stack>
      )}
    </StyledAppBar>
  );
}

type StyledAppBarProps = {
  drawerOpen: boolean;
};

const StyledAppBar = styled("div")<StyledAppBarProps>`
  position: absolute;
  top: 0;
  z-index: ${({ theme }) => theme.zIndex.drawer};
  padding: 24px 0 1rem 0.75rem;
  display: flex;
  justify-content: space-between;
  width: 100%;
  transition: width 0.2s;

  ${({ theme }) => theme.breakpoints.down("sm")} {
    // padding: 1rem 1rem 1rem 0;
    padding: 1rem;
    background-color: rgb(33 42 50 / 80%);
    backdrop-filter: blur(10px);
    min-height: 80px;
  }
`;

const DrawerToggleButton = styled(Button)`
  background-color: ${({ theme }) => theme.palette.background.default};
  height: 56px;
  min-width: unset;
  border-top-left-radius: 12px;
  border-bottom-left-radius: 12px;
  padding: 14px 6px;

  &:hover {
    background-color: ${({ theme }) => theme.palette.background.default};
  }
`;
